export const XXS_SCREEN = "600px";
export const XS_SCREEN = "750px";
export const S_SCREEN = "900px";
export const MD_SCREEN = "1000px";
export const LG_SCREEN = "1366px";
